module.exports = {
  publicPath: '/schizo-syntasis',
}
